// extracted by mini-css-extract-plugin
export var chip = "_fp-0";
export var filterDropdown = "_fp-5";
export var filterItem = "_fp-6";
export var icon = "_fp-1";
export var removeButton = "_fp-3";
export var removeIcon = "_fp-4";
export var separator = "_fp-2";